import { render, staticRenderFns } from "./FieldFile.vue?vue&type=template&id=71b6c5de&"
import script from "./FieldFile.vue?vue&type=script&lang=js&"
export * from "./FieldFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports